import React, { useEffect, useState } from 'react';
import { useSuccessionTheme } from '../Succession/SuccessionThemeProvider';

const lightenHex = (hex, amount = 0.12) => {
  try {
    const n = hex.replace('#', '');
    const num = parseInt(n, 16);
    let r = (num >> 16) & 0xff;
    let g = (num >> 8) & 0xff;
    let b = num & 0xff;
    r = Math.min(255, Math.round(r + (255 - r) * amount));
    g = Math.min(255, Math.round(g + (255 - g) * amount));
    b = Math.min(255, Math.round(b + (255 - b) * amount));
    return `rgb(${r}, ${g}, ${b})`;
  } catch (_) { return hex; }
};

const OpportunitiesWelcomeBanner = () => {
  const { company } = useSuccessionTheme();
  const primary = company?.primary_color || 'var(--succession-primary)';
  const secondary = company?.secondary_color || 'var(--succession-secondary)';
  // Match Succession banner behavior: gradient from secondary -> primary
  const gradient = `linear-gradient(90deg, ${secondary} 0%, ${primary} 100%)`;

  const [logoUrl, setLogoUrl] = useState(null);
  useEffect(() => {
    try {
      const headerLogo = document.querySelector('header img[data-light-logo]');
      if (headerLogo) {
        const dark = headerLogo.getAttribute('data-dark-logo') || headerLogo.getAttribute('data-light-logo') || headerLogo.src;
        setLogoUrl(dark);
      }
    } catch (_) {}
  }, []);

  return (
    <div className="rounded-2xl overflow-hidden shadow-succession-lg border border-succession-border" style={{ backgroundImage: gradient }}>
      <div className="p-4 md:p-6 lg:p-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-center">
          <div className="md:col-span-4">
            <div className="rounded-xl overflow-hidden flex items-center justify-center aspect-[4/3]">
              {logoUrl && <img src={logoUrl} alt={company?.branded_name || company?.name || 'Company'} className="max-h-24 w-auto object-contain" />}
            </div>
          </div>
          <div className="md:col-span-8 text-white">
            <h2 className="m-0 p-0 text-2xl md:text-3xl font-bold">Marketplace Hub for Discovery & Transactions</h2>
            <p className="mt-3 text-base md:text-lg leading-relaxed text-white/85 max-w-2xl">
              Connect with advisors and firms, build teams, and transact. This is your engine for discovery, teaming, and marketplace activity.
            </p>
            <div className="mt-5">
              <a href="/succession/search" className="inline-flex items-center px-5 py-2.5 rounded-full bg-succession-primary text-white hover:bg-succession-primary-hover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-succession-primary transition-colors duration-150 font-medium">Start Exploring</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OpportunitiesWelcomeBanner;


